<!-- eslint-disable -->
<template>
    <div class="card card-custom gutter-b">
        <!--begin::Header-->
        <div class="card-header border-0 py-5">
            <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">Клиенты</span>
            </h3>
        </div>
        <!--end::Header-->

        <!--begin::Body-->
        <div class="card-body pt-0">
            <div class="tab-content">
                <!--begin::Table-->

                <div v-if="clients.length === 0" class="text-center mb-10">
                    Клиенты не найдены!
                </div>

                <div v-if="load" class="text-center mb-10">
                    <b-spinner variant="primary" label="Text Centered"></b-spinner>
                </div>


                <div v-else class="table-responsive">
                    <table class="table table-head-custom table-head-bg table-borderless table-vertical-center">
                        <thead>
                        <tr class="text-left text-uppercase">
                            <th class="pl-7"><span class="text-dark-75">Имя</span></th>
                            <th>Заказы</th>
                            <th>Сумма всех заказов</th>
                            <th>Дата регистрации</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="(client, i) in clients">
                            <tr v-bind:key="i">
                                <td class="pl-0 py-8">
                                    <div class="d-flex align-items-center">

                                        <span v-if="client.account && client.account.image" class="symbol symbol-50 symbol-light-success mr-4">
                                            <img :src="$urlBackEnd(client.account.image)" class="h-75" alt=""/>
                                        </span>

                                        <div v-else class="symbol symbol-50 symbol-light mr-4">
                                            <span class="symbol-label">
                                                <img src="/media/svg/avatars/032-boy-13.svg" class="h-75 align-self-end" alt=""/>
                                            </span>
                                        </div>
                                        <div>
                                            <router-link :to="{ name: 'Client', params: {id: client.id}}" class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{client.name + ' ' + client.surname}}</router-link>
                                            <span v-if="client.account" class="text-muted font-weight-bold d-block">{{client.account.name}}</span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <span v-if="client.orders" class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                        {{client.orders.length}}
                                    </span>
                                    <span v-else class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                        Нет заказов
                                    </span>
                                </td>
                                <td>
                                    <span v-if="client.orders.length > 0" class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                         {{ numberWithSpaces(sumAllOrders(client.orders)) }}  руб.
                                    </span>

                                    <span v-else class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                         0 руб.
                                    </span>
                                </td>
                                <td>
                                    <span class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                        {{ moment(client.created_at).format('lll') }}
                                    </span>
                                </td>
                                <td class="pr-0 text-right">
                                    <router-link :to="{ name: 'Client', params: {id: client.id}}" class="btn btn-light-success font-weight-bolder font-size-sm">Открыть</router-link>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
                <!--end::Table-->

                <Paginate v-if="load === false" :route_link="'Clients'" :filter="filter" />

            </div>
        </div>
        <!--end::Body-->
    </div>
    <!--end::Advance Table Widget 4-->


</template>

<script>
    import moment from "moment";
    require('moment/locale/ru');
    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import {GET_CLIENTS} from "../../../core/services/store/clients.module";
    import {SET_ALERT} from "../../../core/services/store/alert.module";
    import Paginate from "../Paginate";
    export default {
        name: "Clients",
        components: {Paginate},
        mounted(){
            this.$store.dispatch(SET_BREADCRUMB, [{ title: "Все клиенты" }]);
            this.getFilter()
        },

        computed: {
            ...mapGetters({
                paginate: 'paginateGetters',
                clients: 'gettersClients',
                load: 'getClientLoad'
            })

        },

        data(){
            return{
                moment:moment,
                filter: {
                    to: '50',
                },
            }
        },

        methods:{
            numberWithSpaces(x){

                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");


            },

            async getFilter(){
                try {
                    await this.$store.dispatch(GET_CLIENTS, {'page': this.$route.params.page, 'filter': this.filter})
                    if (this.clients.length === 0 && this.paginate.total > 0){
                        this.$router.push({ name: 'Clients', params: {page: 1}})
                    }
                } catch (e) {
                    this.showAlert('Ошибка загрузки', 'danger', 'toast');
                }
            },

            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },


            sumAllOrders(orders){
                let sum = 0;
                orders.forEach( order => {
                    sum = Number(sum) + Number(order.payment.sum);
                });

                return sum
            }


        },

        watch: {

            $route: function () {
                this.getFilter()
            },

            "filter.to": function() {
                this.getFilter()
            },
        }


    }
</script>

<style scoped>

</style>